import { AfterViewInit, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../../../../shared/services/auth.service';
import { ViewProductInfoHandlerService } from '../../../../services/view-product-info-handler.service';
import { CurrencyExchangeService } from '../../../../../../shared/services/currency-exchange.service';
import { BaseTemplate } from '../../../../../../shared/baseTemplate';
import { GetBusinessProfileService } from '../../../../../../shared/services/get-business-profile.service';
import { GetCalculatesParamsService } from '../../../../services/get-calculates-params.service';
import { MapDialogComponent } from '../../../../../../shared/components/map-dialog/map-dialog.component';

@Injectable({
  providedIn: 'root'
})

export abstract class BaseEvent extends BaseTemplate implements AfterViewInit {
  eventTicketsArray: any[] = [];
  ticketPrices: any[] = [];
  ticketPricesTest: any = {};
  constructor(
    private dialog: MatDialog,
    public vpihs: ViewProductInfoHandlerService,
    public auth: AuthService,
    public getBusinessProfileService: GetBusinessProfileService,
    public exchangeService: CurrencyExchangeService,
    public getCalculatesParamsService: GetCalculatesParamsService
  ) {
    super(vpihs, getBusinessProfileService, auth, exchangeService, getCalculatesParamsService);
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  getEventQuantityArray(eventQuantity: number) {
    const eventQuantityArray = [];
    for (let i = 0; i < eventQuantity; i++) {
      eventQuantityArray.push(i);
    }
    return eventQuantityArray;
  }

  quantityDownChange(eventValue: any, name: string, price: number, id: number, quantity: number, action?: string) {
    let event = eventValue.target.nextElementSibling.value;
    event = event > quantity ? quantity : event;
    for (const ticketPrice of this.ticketPrices) {
      if (ticketPrice.ticketName === name) {
        ticketPrice.ticketQuantity = event;
      }
    }

    let index = this.ticketPrices.findIndex(ticketPrice => ticketPrice.ticketId === id);
    if (index != -1) {
      if (this.ticketPrices[index] && this.ticketPrices[index].ticketQuantity >= 1) {
        this.ticketPrices[index].ticketQuantity = Number(this.ticketPrices[index].ticketQuantity);
      }
      else {
        this.ticketPrices.splice(index, 1);
      }
    }

    this.extrasObject = {
      isEvent: true,
      selectedTickets: this.ticketPrices
    };
    this.quantity = this.ticketPrices.length;
    this.calculateSubTotalAmount();
  }

  quantityUpChange(eventValue: any, name: string, price: number, id: number, quantity: number, action?: string) {

    let event = eventValue.target.previousElementSibling.value;
    event = event > quantity ? quantity : event;
    for (const ticketPrice of this.ticketPrices) {
      if (ticketPrice.ticketName === name) {
        ticketPrice.ticketQuantity = event;
      }
    }
    const addTicket=()=>{
      this.ticketPrices.push({
        ticketPrice: price,
        ticketQuantity: event,
        ticketName: name,
        ticketId: id
      });
    }
    let index = this.ticketPrices.findIndex(ticketPrice => ticketPrice.ticketId === id);
    if (index != -1) {
      this.ticketPrices[index].ticketQuantity = Number(this.ticketPrices[index].ticketQuantity);
    }
    else {
        addTicket();
    }


    this.extrasObject = {
      isEvent: true,
      selectedTickets: this.ticketPrices
    };
    this.quantity = this.ticketPrices.length;
    this.calculateSubTotalAmount();
  }

  calculateSubTotalAmount() {
    let subtotal = 0;
    for (const ticketPrice of this.ticketPrices) {
      const totalTicketPrice =
        ticketPrice["ticketPrice"] * ticketPrice["ticketQuantity"];
      subtotal += totalTicketPrice;
    }
    this.subtotal = this.vpihs.getExchangedValue(
      subtotal,
      this.getNewProductValueByFieldName("currency", "ProductExtraInfos")
    );
    return this.subtotal;
  }
  resetAfterProductChange(){
    this.extrasObject=null;
    this.quantity=0;
    this.subtotal=0;
    this.ticketPrices=[];
  }
  getFeesFromSeller() {
    const feesStringValue = this.getNewProductValueByFieldName('feesOnBuyerFlag', 'ProductExtraInfos');
    let netFees = 0;
    if (feesStringValue === "true" || feesStringValue === "1") {
      const feesValue = this.businessObject.fees;
      const feesType = this.businessObject.fees_type;
      if (feesType === "Percentage") {
        let amount = 0;
        for (const ticketPrice of this.ticketPrices) {
          const totalTicketPrice =
            ticketPrice["ticketPrice"] * ticketPrice["ticketQuantity"];
          amount += totalTicketPrice;
        }
        if (this.dicountValue < -0) {
          let discount;
          if (this.vpihs.currency != 'EGP') {
            discount = +(this.dicountValue * this.getExchangeRateToEGP(this.vpihs.currency)) || 0;
          }
          else {
            discount = +this.dicountValue || 0;
          }
          netFees = ((amount - Math.abs(discount)) + this.vpihs.taxes) * (Number(feesValue) / 100);
        }
        else {
          netFees = ((amount + this.vpihs.taxes) * Number(feesValue)) / 100;
        }
        console.log("netFees", netFees)
      } else {
        netFees = feesValue;
      }
      const feesObject = {
        name: "Buyer Fees",
        value: this.vpihs.getExchangedValue(netFees, this.vpihs.currency)
      };
      return feesObject;
    } else {
      return null;
    }
  }

  openMap() {
    const dialogRef = this.dialog.open(MapDialogComponent, {
      height: "400px",
      width: "500px",
      data: {
        coordinates: this.getNewProductValueByFieldName("eventLocation", "EventProductExtraInfo")
      }
    });
  }
  basePrice(egpPrice:number, currency:string){
    return this.vpihs.getExchangedValue(
      egpPrice,
      currency
    );
  }
}
